module.exports = __webpack_public_path__ + "static/media/map.7e329610.svg";